import { Component, OnInit, Input } from "@angular/core";
import { ProfessionService } from "../../../core/profession.service";
import { Router } from "@angular/router";
import { Profession } from "../../../models";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from "app/utils/notifications.service";

@Component({
  selector: "app-ajouter",
  templateUrl: "./ajouter.component.html",
  styleUrls: ["./ajouter.component.css"]
})
export class AjouterComponent implements OnInit {
  @Input()
  profession:Profession;
  form: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
    private notification: NotificationsService,
    private professionService: ProfessionService,
  ) { }


  ngOnInit() {
    this.initForm();
  }

  submitForm() {
    const valeur: any = this.form.value;

    console.log(valeur);
    this.professionService.create(valeur).subscribe(
      profession => {
        if (this.profession) {
          this.notification.addToast(
            "catheter Modifié",
            "infos",
            "success"
          );
        } else {
          this.notification.addToast(
            "catheter bien créé",
            "infos",
            "success"
          );
        }
      },
      error => {
        if (this.profession) {
          this.notification.addToast(
            "Erreur sur Modification",
            'Attention', 'error'
          );
        } else {
          this.notification.addToast(
            "Erreur sur Création",
            'Attention', 'error'
          );
        }
      }
    );

    this.activeModal.dismiss("cancelled by user");
    this.ngOnInit();
  }


  public initForm() {
    if (this.profession) {
      this.form = this.formBuilder.group({
        libelle: [this.profession.libelle, Validators.required],
        id: [this.profession.id]
      });
    } else {
      this.form = this.formBuilder.group({
        libelle: [null, Validators.required],
        id: [null]
      });
    }
  }
  dismiss() {
    this.activeModal.dismiss("cancelled by user");
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/parametrage/profession/ajouter/ajouter.component.ts